import React, { useEffect, useState  } from 'react';
import '../Card/card-style.css';
import fantasticSubmitData from '../data/fantasticsubmit.json'
import storage from '../factory/StorageFactory';
import FormContainer from '../components/FormContainer';
import config from '../appconfig/config.json';


const fsaData = fantasticSubmitData;

const SubmitSaveAndContinue = props => {
   const [refNo, setRefNo] = useState('');
   const [expiredDate,setExpiredData] = useState('');

   useEffect(() => {
     
       window.scrollTo(0,0);
       setRefNo(storage.getRefNo());
       if(props.location.state !== undefined) {
        setExpiredData(props.location.state.expDate);
       }

       clearData();
    }, []);

   const clearData =()=> {
       if(storage.getStateId() !== null){
           storage.clearAll();
       }
   }

 

   const handleOk = () => {
    window.location.href = config.link.Cancle;
   }

   return(
         <FormContainer>
          <div className="row around-xs elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <legend id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px'}}>{'Your application is on hold'}</legend>
                </div>
            </div>
            <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
          
            <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div id={'lmsg2'} style={{textAlign:'center',fontSize:'1.3em',fontWeight:'400',paddingTop:'20px'}}>
                    {'Do complete your application before '}{expiredDate}{' to avoid reapplying.'}
                </div>
                <div style={{textAlign:'center',fontSize:'1.3em',fontWeight:'400',paddingTop:'20px'}}>
                    {'Refer to your email for more information.'} 
                </div>
            </div>
            </div>
           
            <div className="row around-xs inputPair elementVisible">
            <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="text-center" style={{padding: "30px"}}>
                <div>
                <button className="k-button btn btn-success" onClick={handleOk}>OK</button>
                </div>
            </div>
            </div>                          
            </div> 

           </FormContainer>
 
    
   );
}

export default SubmitSaveAndContinue;